import { render, staticRenderFns } from "./Infraction.vue?vue&type=template&id=1ca7e8e2&"
import script from "./Infraction.vue?vue&type=script&lang=js&"
export * from "./Infraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports